import Dashboard from "./MissionControl/Dashboard";
import Meals from "./WarriorTracker/Meals";
import PersonalBests from "./WarriorTracker/PersonalBests";
import Quotes from "./Quotes/Quotes";
import GreatnessWithin from "./CoachingTools/GreatnessWithin/GreatnessWithin";
import SentenceCompletion from "./CoachingTools/SentenceCompletion/SentenceCompletion";
import ValuesDiscovery from "./CoachingTools/ValuesDiscovery/ValuesDiscovery";
import WheelOfLife from "./CoachingTools/WheelOfLife/WheelOfLife";

/**
 * Register global Vue components below and they will be auto-registered
 * with the root instance.
 */
export default {
    'fc-dashboard':           Dashboard,
    'fc-meals-stats':         Meals,
    'fc-personal-bests':      PersonalBests,
    'fc-quotes':              Quotes,
    'fc-greatness-within':    GreatnessWithin,
    'fc-sentence-completion': SentenceCompletion,
    'fc-values-discovery':    ValuesDiscovery,
    'fc-wheel-of-life':       WheelOfLife
};
